import { Resource } from '../shared/resource';

export class CondensedJobEventFilter extends Resource {
  id: string;
  name: string;
  loading: boolean;
}
